import {createSlice} from "@reduxjs/toolkit";

const auth = {
    success: false,
    errors: [],
    token: '',
    refreshToken: '',
    user: {
        email: '',
        mobile: '',
        profiles: [],
    }
};

// TODO: Review what to store , just token or more data
const authInitialData = localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : auth;
const activeSeasonSelectionsInitialData = localStorage.getItem("activeSeasonSelections")
    ? JSON.parse(localStorage.getItem("activeSeasonSelections"))
    : {};

const userSlice = createSlice({
    name: 'user',
    initialState: {
        auth: authInitialData,
        activeSeasonSelections: activeSeasonSelectionsInitialData,
    },
    reducers: {
        login: (state, action) => {
            localStorage.setItem('auth', JSON.stringify(action.payload));
            let authData = JSON.parse(localStorage.getItem('auth'));
            authData.user.profiles[0].activeInWeb = true;
            state.auth = authData;
            localStorage.setItem('auth', JSON.stringify(authData));
        },
        logout: (state) => {
            state.auth = auth;
            state.activeSeasonSelections = {};
            localStorage.removeItem('auth');
            localStorage.removeItem("activeSeasonSelections");
        },
        activeProfile(state, action) {
            const nextId = action.payload;

            const auth = state.auth;
            const user = auth?.user;

            if (!auth || !user) return;

            const profiles = Array.isArray(user.profiles) ? user.profiles : [];

            const updatedProfiles = profiles.map((p) => ({
                ...p,
                activeInWeb: String(p.id) === String(nextId),
            }));

            // ✅ IMPORTANT: write back into Redux state immutably
            state.auth = {
                ...auth,
                user: {
                    ...user,
                    profiles: updatedProfiles,
                },
                // ✅ "version bump" to force subscribers/pages to react even if ids repeat
                profileVersion: (auth.profileVersion || 0) + 1,
            };

            localStorage.setItem("auth", JSON.stringify(state.auth));
        },
        selectActiveSeason(state, action) {
            const { profileId, divisionSlug, seasonSlug } = action.payload || {};
            if (!profileId || !divisionSlug || !seasonSlug) return;

            const selectionKey = `${profileId}:${divisionSlug}`;
            state.activeSeasonSelections[selectionKey] = seasonSlug;
            localStorage.setItem(
                "activeSeasonSelections",
                JSON.stringify(state.activeSeasonSelections)
            );
        },
    }
});

export const userActions = userSlice.actions;
export default userSlice.reducer;
